<template>
  <div style="padding: 10px">
    <el-descriptions :column="3" border class="desc-box">
      <el-descriptions-item label="姓名" label-align="right">
        <div>
          {{ state.model?.name || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="证件类型" label-align="right">
        <div>
          {{ state.model?.idtype || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="证件号" label-align="right">
        <div>
          {{ state.model?.idcard || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="证件生效日" label-align="right">
        <div>
          {{ state.model?.id_start || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="证件到期日" label-align="right">
        <div>
          {{ state.model?.id_end || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="性别" label-align="right">
        <div>
          {{ state.model?.sex == 0 ? "男" : "女" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="民族" label-align="right">
        <div>
          {{ state.model?.nation || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="婚姻状况" label-align="right">
        <div>
          {{ state.model?.marital_status || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="生育状况" label-align="right">
        <div>
          {{ props.model?.fertility_status || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="政治面貌" label-align="right">
        <div>
          {{ state.model?.political_status || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="籍贯" label-align="right">
        <div>
          {{ state.model?.household_type || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="户籍城市" label-align="right">
        <div>
          {{ state.model?.household_city || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="户籍详细地址" label-align="right">
        <div>
          {{ state.model?.household_address || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="户口性质" label-align="right">
        <div>
          {{ state.model?.native_place || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="参加工作日期" label-align="right">
        <div>
          {{ state.model?.work_date || "-" }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="学历" label-align="right">
        <div>
          {{ state.model?.education || "-" }}
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { employee_info } from "@/http/employee";
export default {
  props: {
    employee_id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      if (props.employee_id) {
        employee_info(props.employee_id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
          }
        });
      }
    });
    return { state, props };
  },
};
</script>
<style scoped></style>
